export const FONT_OPTIONS = [
  { label: 'Times New Roman', value: 'timesNewRoman' },
  { label: 'Poppins', value: 'poppins' },
  { label: 'Arial', value: 'arial' },
  { label: 'Inter', value: 'inter' },
  { label: 'Cairo', value: 'cairo' },
  { label: 'Roboto', value: 'roboto' },
].map((option) => ({
  ...option,
  style: { fontFamily: option.label },
}));

export const FONT_SIZES = [
  { label: '14px', value: '14px' },
  { label: '16px', value: '16px' },
  { label: '18px', value: '18px' },
  { label: '20px', value: '20px' },
];

export const SYSTEM_FONT_URLS = {
  poppins: 'https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJA.ttf',
  cairo: 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hGA-W1Q.ttf',
  roboto: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5Q.ttf',
};
